import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Icon } from "@iconify/react/dist/iconify.js";
import { Box, ButtonBase, FormHelperText, Grid, Stack } from "@mui/material";
import moment from "moment";
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import AppDialog from "../../components/Common/AppDialog";
import AppTab from "../../components/Common/AppTab";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import TableStyle2 from "../../components/Common/TableStyle2";
import CustomAutocomplete from "../../components/Form/CustomAutocomplete";
import CustomButton from "../../components/Form/CustomButton";
import CustomSelect from "../../components/Form/CustomSelect";
import CustomTextField from "../../components/Form/CustomTextField";
import CustomizedDatePicker from "../../components/Form/DatePicker";
import UploadProductImagesNew from "../../components/Form/UploadProductImagesNew";
import Helpers from "../../helpers/helpers";
// import PlateNoDetectionHelper from "../../helpers/plate_no_detection_helper";
import { getAdvertDetails, getAdvertInterestRate, getCoeBiddingList, getGeneral, resetAdvertActionState, resetAdvertState, updateAdvert } from "../../store/actions";
import FormEditors from "../Forms/FormEditors";
import "./advert.css";
import PlanInfo from "./Form/PlanInfo";
import BindingResult from "./modal/BindingResult";
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import AddSalesman from "./modal/AddSalesman";

const newPriceTypeList = [
    { label: 'OTR Price', value: 1 },
    { label: 'Downpayment', value: 2 },
    { label: 'Promotion Price', value: 3 },
]

const newPricingTypeExplanations = [
    {
        value: 1,
        title: 'OTR Price',
        description: 'Price shown is indicative and based on the latest COE results. It is automatically updated after each COE exercise. Final pricing may vary. Insurance is not included.',
    },
    {
        value: 2,
        title: 'Downpayment',
        description: 'The downpayment and monthly instalment shown are fixed and will not be affected by future COE price changes.',
    },
    {
        value: 3,
        title: 'Promotion Price',
        description: 'Includes a valid, in-stock COE and will not be affected by future COE price changes.',
    },
]

const usedPriceTypeList = [
    { label: 'Selling Price', value: 4 },
    { label: 'Downpayment', value: 2 },
    { label: 'Promotion Price', value: 3 },
]

const directSellerPriceTypeList = [
    { label: 'Selling Price', value: 4 },
    // { label: 'Promotion Price', value: 3 },
]

const EditAdvert = ({ leftSideBarType, layoutWidth, makeList, modelList, bodyList, license_categories, advertDetails,
    salesmanList, locationList, advertInterestRate, advertEdit, taggings, isDirectSeller, userEmail, userPhone,
    username, coeList, transmissionList, planList, userData, generalCommonCode, advertDetailsInd, defaultColorList }) => {
    const isSingPass = Boolean(advertDetails?.myinfo_make || advertDetails?.myinfo_model);
    const isPublished = advertDetails?.status === "published";
    const isDirectPublished = isDirectSeller && isPublished && !isSingPass;
    const isDirectSingPassPublished = isDirectSeller && isPublished && isSingPass;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { ID } = useParams();
    const [newSalesman, setNewSalesman] = useState([]);
    const [bindingResultOpen, setBindingResultOpen] = useState(false);
    const [formObj, setFormObj] = useState({});
    const [selectedRow, setSelectedRow] = useState();
    const [tabValue, setTabValue] = useState('vehicle_info');
    const [currentScrollBranch, setCurrentScrollBranch] = useState('vehicle-info-section');
    const [preSelectBodyType, setPreSelectBodyType] = useState([]);
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const [isScrolling, setIsScrolling] = useState(false);
    const [interestRateOptions, setInterestRateOptions] = useState([]);
    const [loading, setIsLoading] = useState(false);
    const [photoState, setPhotoState] = useState(0);
    const [showSubmitLoadingMessage, setShowSubmitLoadingMessage] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState();
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [defaultOpen, setDefaultOpen] = useState(false);
    const [newContact, setNewContact] = useState({});
    const [openAddSalesManModal, setOpenAddSalesManModal] = React.useState();
    const [editIdx, setEditIdx] = React.useState(null);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [error, setError] = useState({});
    const tabList = [
        { value: 'vehicle_info', label: `Vehicle Info`, target: 'vehicle-info-section' },
        { value: 'pricing', label: `Pricing`, target: 'pricing-info-section' },
        { value: 'ad_details', label: `Ad Details`, target: 'ad-details-section' },
        { value: 'salesman', label: `${isDirectSeller ? 'Contact' : 'Salesman'}`, target: 'salesman-section' },
        { value: 'media', label: `Media`, target: 'media-section' },
    ];
    const make_name = makeList?.find((x) => x.id === formObj?.make_id)?.name || '';
    const model_name = modelList?.find((x) => x.id === formObj?.model_id)?.name || '';

    const currentPricingType = formObj?.pricing_type;
    const priceTypeData = formObj?.price_type_data?.[currentPricingType] || {};
    const selectedPricingTypeExplanation = newPricingTypeExplanations.find(
        (item) => item.value === Number(currentPricingType)
    );

    useEffect(() => {
        dispatch(resetAdvertState());
        dispatch(getGeneral());
        dispatch(getAdvertInterestRate());
        dispatch(getCoeBiddingList());
    }, [])

    useEffect(() => {
        if (advertDetails?.id) {

            let tempObj = { ...formObj };
            tempObj.max_loan_tenure_calculated = advertDetails?.max_loan_tenure || null;
            tempObj.default_loan_tenure = advertDetails?.default_loan_tenure || null;

            tempObj.advert_type = advertDetails?.bike_advert_type || null;
            tempObj.bike_advert_plan_id = advertDetails?.advert_plan?.id || null;
            tempObj.make_id = advertDetails?.bike_make_id || null;
            tempObj.model_id = advertDetails?.bike_model_id || null;
            tempObj.register_number = advertDetails?.info?.register_number || null;
            tempObj.license_categories = advertDetails?.info?.license_category || null;
            tempObj.model_colour_id = advertDetails?.info?.bike_model_colour_id || null;
            tempObj.colour_text = advertDetails?.info?.colour_text || null;
            tempObj.body_type = advertDetails?.bike_types ? advertDetails?.bike_types?.map((type) => type.bike_type_id) : null;
            tempObj.transmission = advertDetails?.info?.transmission || null;
            tempObj.engine_cap = advertDetails?.info?.engine_cc || null;
            tempObj.vehicle_source = advertDetails?.info?.vehicle_source || null;
            tempObj.manu_year = advertDetails?.info?.manu_year || null;
            tempObj.registration_date = advertDetails?.info?.registration_date || null;
            tempObj.coe_expiry = advertDetails?.info?.coe_expiry ? moment(advertDetails?.info?.coe_expiry).format('YYYY-MM-DD') : null;
            tempObj.mileage_in_km = advertDetails?.info?.mileage_in_km;
            tempObj.no_of_previous_owners = advertDetails?.info?.no_of_previous_owners;
            //pricing — build from pricings array
            const pricings = advertDetails?.pricings || [];
            const activePricing = isDirectSeller ? { pricing_type: 4 } : pricings.find(p => p.is_active === 1) || pricings[0] || {};
            const activePricingType = activePricing?.pricing_type || null;
            const type1 = pricings.find(p => p.pricing_type === 1) || {};
            const type3 = pricings.find(p => p.pricing_type === 3) || {};
            const type4 = pricings.find(p => p.pricing_type === 4) || {};
            tempObj.pricing_type = activePricingType;
            tempObj.machine_price = type1?.machine_price != null ? Number(type1.machine_price).toFixed(2) : "0.00";
            tempObj.coe = type1?.coe != null ? Number(type1.coe).toFixed(2) : "0.00";
            tempObj.additional_costs = type1?.additional_cost != null ? Number(type1.additional_cost).toFixed(2) : "0.00";
            tempObj.promotion_price = type3?.promotion_price != null ? Number(type3.promotion_price).toFixed(2) : "0.00";
            tempObj.selling_price = (type4?.selling_price ?? type4?.price) != null ? Number(type4?.selling_price ?? type4?.price).toFixed(2) : "0.00";
            tempObj.purchase_cost = activePricing?.purchase_cost != null ? Number(activePricing.purchase_cost).toFixed(2) : "0.00";
            tempObj.recommended_selling_price = activePricing?.recommended_selling_price != null ? Number(activePricing.recommended_selling_price).toFixed(2) : "0.00";
            tempObj.arf = activePricing?.arf != null ? Number(activePricing.arf).toFixed(2) : "0.00";
            // per-price-type data — one entry per pricing in the array
            tempObj.price_type_data = {};
            pricings.forEach(p => {
                tempObj.price_type_data[p.pricing_type] = {
                    min_downpayment: Number(p.min_downpayment)?.toFixed(2) || "0.00",
                    max_loan_tenure: p.max_loan_tenure ?? "0",
                    interest_rate: Number(p.interest_rate)?.toFixed(2) || 0,
                    loan_amount: Number(p.loan_amount)?.toFixed(2) || "0.00",
                    monthly_instalment: Number(p.monthly_instalment)?.toFixed(2) || "0.00",
                    term_charge: Number(p.term_charge)?.toFixed(2) || "0.00",
                    machine_price: p.machine_price != null ? Number(p.machine_price).toFixed(2) : "0.00",
                    coe: p.coe != null ? Number(p.coe).toFixed(2) : "0.00",
                    additional_costs: p.additional_cost != null ? Number(p.additional_cost).toFixed(2) : "0.00",
                    promotion_price: p.promotion_price != null ? Number(p.promotion_price).toFixed(2) : "0.00",
                    selling_price: (p.selling_price ?? p.price) != null ? Number(p.selling_price ?? p.price).toFixed(2) : "0.00",
                };
            });
            //rental
            tempObj.daily_rate = advertDetails?.rental_rate?.daily_rate || null;
            tempObj.weekend_rate = advertDetails?.rental_rate?.weekend_rate || null;
            tempObj.three_day_rate = advertDetails?.rental_rate?.['3_days_rate'] || null;
            tempObj.weekly_rate = advertDetails?.rental_rate?.weekly_rate || null;
            tempObj.monthly_rate = advertDetails?.rental_rate?.monthly_rate || null;
            // tempObj.title = advertDetails?.info?.title || null;
            tempObj.title_remark = advertDetails?.info?.title_remark || null;
            tempObj.description = advertDetails?.info?.description || null;
            tempObj.taggings = advertDetails?.taggings ? advertDetails?.taggings?.map((tag) => tag.tagging_id) : [];
            tempObj.featured_tagging_id = advertDetails?.featured_tagging_id
                ?? advertDetails?.featured_tagging_id
                ?? advertDetails?.taggings?.find((tag) => tag.is_featured)?.tagging_id
                ?? null;
            tempObj.test_ride_url = advertDetails?.info?.test_ride_url || null;
            tempObj.test_ride_salesman_id = advertDetails?.info?.test_ride_salesman_id || null;
            tempObj.youtube_url = advertDetails?.info?.youtube_url || null;
            tempObj.facebook_url = advertDetails?.info?.facebook_url || null;
            tempObj.instagram_url = advertDetails?.info?.instagram_url || null;
            tempObj.tiktok_url = advertDetails?.info?.tiktok_url || null;
            tempObj.salesmans = advertDetails?.salesmans || null;
            // tempObj.thumbnail = advertDetails?.images?.length > 0 ?
            //     advertDetails.images?.filter((image) => image.type === 'thumbnail')?.map((img) => { return ({ id: img?.id, file_name: img?.attachment_name, file_base64: img?.base64 }) }) || null : null;
            tempObj.photos = advertDetails?.images?.length > 0 ?
                advertDetails.images?.filter((image) => image)?.map((img) => { return ({ id: img?.id, file_name: img?.attachment_name, file_base64: img?.base64, is_thumbnail: img?.type === "thumbnail" ? true : false }) }) || null : null;

            if (isDirectSeller) {
                tempObj.contacts = advertDetails?.salesmans?.length > 0 ? advertDetails?.salesmans : null;
            }
            setFormObj(tempObj);
        }
        handlePreselectBikeTypes(true)
    }, [advertDetails, makeList])

    useEffect(() => {
        if (advertDetailsInd?.code && advertDetailsInd?.code !== 'success') {
            setIsLoading(false);
        }
    }, [advertDetailsInd]);

    useEffect(() => {
        const selectedLicenseCategoryId = Number(formObj?.license_categories);
        const baseList = advertDetails?.interest_rates?.filter(
            (ir) => ir?.license_category_id == null || Number(ir?.license_category_id) === selectedLicenseCategoryId
        ) || [];
        // Preserve any custom entries the user typed that aren't in the base list
        setInterestRateOptions(prev => {
            const customEntries = prev.filter(
                (p) => !baseList.some((b) => Number(b.interest_rate) === Number(p.interest_rate))
            );
            return [...baseList, ...customEntries];
        });
    }, [advertDetails, formObj?.license_categories, formObj?.advert_type, license_categories])

    useEffect(() => { //calculate term charge then monthly instalment using fresh term charge value
        const rawInterest = priceTypeData?.interest_rate;
        const interestRate = (rawInterest === "NaN" || rawInterest == null) ? 0 : Number(rawInterest);
        const loanAmount = Number(priceTypeData?.loan_amount || 0);
        const tenure = Number(priceTypeData?.max_loan_tenure || 0);

        const termCharge = (loanAmount * (tenure / 12) * interestRate / 100).toFixed(2);
        const totalPayable = loanAmount + parseFloat(termCharge);
        const monthlyInstalment = tenure > 0 ? (totalPayable / tenure) : 0;

        if (termCharge !== priceTypeData?.term_charge) {
            handlePTDChange('term_charge', termCharge);
        }
        const formattedInstalment = isFinite(monthlyInstalment) && monthlyInstalment > 0 ? Math.ceil(monthlyInstalment).toFixed(2) : "0.00";
        if (formattedInstalment !== priceTypeData?.monthly_instalment) {
            handlePTDChange('monthly_instalment', formattedInstalment);
        }
    }, [priceTypeData?.loan_amount, priceTypeData?.interest_rate, priceTypeData?.max_loan_tenure])

    useEffect(() => {
        const minDownpayment = Number(priceTypeData?.min_downpayment || 0);
        let loanAmount = "0.00";

        if (formObj?.pricing_type === 1) {
            loanAmount = (Number(priceTypeData?.machine_price || 0) + Number(priceTypeData?.coe || 0) + Number(priceTypeData?.additional_costs || 0) - minDownpayment).toFixed(2);
        } else if (formObj?.pricing_type === 3) {
            loanAmount = (Number(priceTypeData?.promotion_price || 0) - minDownpayment).toFixed(2);
        } else if (formObj?.pricing_type === 4) {
            loanAmount = (Number(priceTypeData?.selling_price || 0) - minDownpayment).toFixed(2);
        }

        if (formObj?.pricing_type !== 2 && loanAmount !== priceTypeData?.loan_amount) {
            handlePTDChange('loan_amount', loanAmount);
        }
    }, [formObj?.pricing_type, priceTypeData?.min_downpayment, priceTypeData?.machine_price, priceTypeData?.coe, priceTypeData?.additional_costs, priceTypeData?.promotion_price, priceTypeData?.selling_price])


    useEffect(() => {
        if (advertEdit?.code === 'success') {
            setNotification({ open: true, msg: advertEdit?.message || 'Advert updated successfully', type: 'success' });
            setIsLoading(false);
            setShowSubmitLoadingMessage(false);
            error && setError({});
            dispatch(resetAdvertActionState());
            navigate(`/advert/${ID}`);
            // dispatch(getAdvertDetails({ id: ID }));

        } else if (advertEdit?.code === "invalid_field" || advertEdit?.code === "error") {
            setError(advertEdit?.errors);
            setNotification({ open: true, msg: advertEdit?.message || 'Invalid fields', type: 'error' });
            setIsLoading(false);
            setShowSubmitLoadingMessage(false);
            dispatch(resetAdvertActionState());
        }
    }, [advertEdit])

    useEffect(() => {
        const sectionIds = tabList.map(t => t.target);
        const handleScroll = () => {
            sectionIds.map((id) => {
                const el = document.getElementById(id);
                if (el && !isScrolling) {
                    const rect = el.getBoundingClientRect();
                    // Check if section is in the viewport area where sidebar is
                    if (rect.top <= 280) {
                        let tab = tabList.find(t => t.target === id)?.value;
                        setTabValue(tab);
                        setCurrentScrollBranch(id);
                        return;
                    }
                }
            })
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [tabList]);

    useEffect(() => {
        if (ID) {
            dispatch(getAdvertDetails({ id: ID }));
        }
    }, [ID])

    const handleSetThumbnail = (file, index) => {
        const updatedPhotos = (formObj?.photos || []).map((photo, photoIndex) => ({
            ...photo,
            is_thumbnail: file?.is_thumbnail ? false : photoIndex === index,
        }));

        if (!updatedPhotos[index]) {
            return;
        }

        handleFormObjChange('photos', updatedPhotos);
    };


    useEffect(() => {
        const makeName = makeList?.find((make) => make.id === formObj?.make_id)?.name || '';
        const modelName = filterModelList?.find((model) => model.id === formObj?.model_id)?.name || '';
        handleFormObjChange('title', `${makeName} ${modelName} ${formObj?.title_remark || ''}`);
    }, [formObj?.make_id, formObj?.model_id, formObj?.title_remark])


    const handleRemoveSalesman = (index) => {
        let temp = [...formObj?.salesmans];
        temp.splice(index, 1);
        handleFormObjChange('salesmans', temp);
        setSelectedRow(null);
    }

    const handlePreselectBikeTypes = (init) => {
        const body_list = filterModelList?.find((item => item?.id == formObj?.model_id)) || [];
        const body_list_ids = body_list?.bike_types?.map((x) => x.bike_type_id) || [];
        const selectedModel = filterModelList?.length > 0 && filterModelList.find((model) => model.id === formObj?.model_id);
        if (selectedModel) {
            // Set license_category_id from the selected model
            // handleFormChange('license_category_id', selectedModel.license_category || "");
            // handleFormChange('transmission', selectedModel.transmission || "");
            // handleFormChange('engine_cap', selectedModel.engine_cc || "");
            // handleFormChange('body_type', body_list_ids || []);
            setPreSelectBodyType(body_list_ids || []);
            // if (formObj?.model_id != selectedModel?.id) {
            !init && setFormObj(prev => ({ ...prev, body_type: body_list_ids || [] }));

            // }
        }
    }

    useEffect(() => {
        handlePreselectBikeTypes(false)
    }, [formObj?.model_id])

    const filterModelList = formObj?.make_id ? makeList.find((make) => make.id === formObj?.make_id)?.models : modelList;
    const filterColorList = filterModelList?.find((item => item?.id === formObj?.model_id))?.colours || [];
    const filterBodyList = filterModelList?.bike_types || bodyList;

    const header = [
        {
            title: 'Name',
            accessor: (item, idx) => {
                const isEdit = selectedRow?.idx === idx ? true : false;
                return (
                    <>
                        {
                            isEdit ?
                                <CustomSelect
                                    values={selectedRow?.salesman_id || '-1'}
                                    onChange={(e) => setSelectedRow({ ...selectedRow, salesman_id: e, salesman_phone: salesmanList.find((salesman) => salesman.id === e)?.phone || '', salesman_name: salesmanList.find((salesman) => salesman.id === e)?.name || '', location_id: salesmanList.find((salesman) => salesman.id === e)?.branch_id || '', location_name: salesmanList.find((salesman) => salesman.id === e)?.branch_name || '' })}
                                    placeholder={'Salesman'}
                                    data={(salesmanList || []).filter(salesman =>
                                        selectedRow?.salesman_id === salesman.id || // Include the currently selected salesman
                                        (!newSalesman.some(newSm => newSm.salesman_id === salesman.id) &&
                                            !formObj?.salesmans?.some(existingSm => existingSm.salesman_id === salesman.id))
                                    ) || []}
                                    labelName={'name'}
                                    valueName={'id'}
                                    height={30}
                                    marginTop="7px"
                                    padding={"0px"}
                                />
                                : item?.salesman_name ? item.salesman_name : salesmanList.find((salesman) => salesman.id === item?.salesman_id)?.name || '-'
                        }
                    </>
                )
            }
        },
        {
            title: 'Branch',
            accessor: (item, idx) => {
                const isEdit = selectedRow?.idx === idx ? true : false;
                return (
                    <>
                        {
                            isEdit ?
                                <CustomSelect
                                    values={selectedRow?.location_id || '-1'}
                                    onChange={(e) => setSelectedRow({ ...selectedRow, location_id: e, location_name: locationList.find((location) => location.id === e)?.branch_name || '' })}
                                    data={locationList || []}
                                    labelName={'branch_name'}
                                    valueName={'id'}
                                    placeholder={'Branch'}
                                    height={30}
                                    marginTop="7px"
                                    padding={"0px"}
                                />
                                : item?.location_name ? item.location_name : locationList.find((location) => location.id === item?.location_id)?.name || '-'
                        }
                    </>
                )
            }
        },
        {
            title: 'Contact',
            accessor: (item, idx) => {
                const isEdit = selectedRow?.idx === idx ? true : false;
                return (
                    <>
                        {
                            isEdit ?
                                selectedRow?.salesman_phone || selectedRow?.contact
                                : item?.salesman_phone || item?.contact || '-'
                        }
                    </>
                )
            }
        },
        {
            title: 'Action',
            accessor: (item, idx) => {
                const isEdit = selectedRow?.idx === idx ? true : false;
                return (
                    <div className="d-flex flex-direction-row">
                        <div
                            style={{ color: isEdit ? '#B48A3C' : '#1D1B1B', cursor: 'pointer', textDecoration: isEdit ? 'underline' : 'none' }}
                            onClick={() => isEdit ? handleEditSalesman(item, idx) : setSelectedRow({ ...item, idx })}
                        >
                            {isEdit ? 'Save' : 'Edit'}
                        </div>
                        <>
                            {isEdit &&
                                selectedRow?.temp_id === item?.temp_id &&
                                <div className="mx-3 clickable" onClick={() => handleRemoveSalesman(idx)} style={{ color: '#D13536' }}>Remove</div>
                            }
                        </>
                    </div>

                )
            }
        },
    ];

    const inputListing = [
        {
            name: 'salesman_id',
            inputType: 'select',
            placeholder: 'Salesman',
            data: (salesmanList || []).filter(salesman =>
                // !newSalesman.some(newSm => newSm.salesman_id === salesman.id) &&
                !formObj?.salesmans?.some(existingSm => existingSm.salesman_id === salesman.id)
            ) || [],
        },
        {
            name: 'location_id',
            inputType: 'select',
            placeholder: 'Branch',
            data: locationList || [],
            labelName: 'branch_name',
            valueName: 'id',
        },
        {
            name: 'contact',
            view: true,
        },
        {
            name: 'action',
            actionName: 'Save',
            removeAction: true,
            actionOnClick: (e) => { handleSaveNewSalesman(e) },
        }
    ]

    const priceTypeList = isDirectSeller ? directSellerPriceTypeList : formObj?.advert_type === 'used' ? usedPriceTypeList : newPriceTypeList;
    const availablePriceTypes = isDirectSeller ? [4, 3] : (formObj?.advert_type === 'used' ? [4, 2, 3] : [1, 2, 3]);
    const currentPriceTypeIndex = availablePriceTypes.indexOf(currentPricingType);
    const pricingError = (field) => currentPriceTypeIndex !== -1
        ? error?.['pricings.' + currentPriceTypeIndex + '.' + field] || error?.[field]
        : error?.[field];

    const handlePTDChange = (field, value) => handlePricingTypeDataChange(currentPricingType, field, value);

    const handleFormObjChange = (key, value) => {
        setFormObj(prev => ({ ...prev, [key]: value }));
    }

    const handlePricingTypeDataChange = (priceType, key, value) => {
        setFormObj(prev => ({
            ...prev,
            price_type_data: {
                ...prev.price_type_data,
                [priceType]: {
                    ...prev.price_type_data?.[priceType],
                    [key]: value,
                },
            },
        }));
    }

    const handleTagChange = (tagValue) => {
        setFormObj((prev) => {
            const selectedTags = prev?.taggings || [];

            if (selectedTags.includes(tagValue)) {
                return {
                    ...prev,
                    taggings: selectedTags.filter((tag) => tag !== tagValue),
                    featured_tagging_id: prev?.featured_tagging_id === tagValue
                        ? null
                        : prev?.featured_tagging_id,
                };
            }

            if (selectedTags.length >= 3) return prev;

            return {
                ...prev,
                taggings: [...selectedTags, tagValue],
                featured_tagging_id: selectedTags.length === 0
                    ? tagValue
                    : prev?.featured_tagging_id,
            };
        });
    }

    const handleFeaturedTagChange = (event, tagValue) => {
        event.stopPropagation();
        handleFormObjChange('featured_tagging_id', formObj?.featured_tagging_id === tagValue ? null : tagValue);
    }

    const scrollToSectionInContainer = (sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
            setIsScrolling(true);
            setCurrentScrollBranch(sectionId);
            const offsetTop = section.offsetTop - (layoutWidth <= 425 ? 350 : layoutWidth <= 768 ? 300 : 250); // Adjust this value based on your fixed header height
            window.scrollTo({ top: offsetTop, behavior: 'smooth' });
            setTimeout(() => {
                setIsScrolling(false); // wait for scrolling to finish
            }, [1000])
        }
    };

    const handleSelectBodyType = (item) => {
        if (preSelectBodyType?.includes(item?.id || item?.bike_type_id)) {
            return
        } else {
            let updatedBodyType = formObj?.body_type ? [...formObj?.body_type] : [];
            if (updatedBodyType.includes(item?.id || item?.bike_type_id)) {
                updatedBodyType = updatedBodyType.filter((type) => type !== (item?.id || item?.bike_type_id));
            } else {
                updatedBodyType.push(item?.id || item?.bike_type_id);
            }
            handleFormObjChange('body_type', updatedBodyType);
        }

    }

    const handleSaveNewSalesman = (salesman) => {
        let temp = Array.isArray(formObj?.salesmans) ? [...formObj?.salesmans] : [];
        temp.push({ ...salesman, temp_id: `edit-${(formObj?.salesmans?.length + 1) || 1}` });
        handleFormObjChange('salesmans', temp);
        //remove from newSalesman
        let updatedNewSalesman = [...newSalesman];
        updatedNewSalesman = updatedNewSalesman.filter((item) => item !== salesman);
        setNewSalesman(updatedNewSalesman);
    }

    const handleEditSalesman = (salesman, index) => {
        let temp = [...formObj?.salesmans];
        temp[index] = { ...selectedRow };
        handleFormObjChange('salesmans', temp);
        setSelectedRow(null);
    }

    const handleTabValue = (value) => {
        setTabValue(value);
        scrollToSectionInContainer(tabList.find(tab => tab.value === value)?.target);
        // Scroll will be handled in useEffect after tabValue updates
    }


    const handleNewContactChange = (key, value) => {
        let tempContacts = { ...newContact };
        tempContacts[key] = value;
        setNewContact(tempContacts);
    }

    const handleEditContactChange = (key, value) => {
        let tempContacts = { ...selectedRow };
        tempContacts[key] = value;
        setSelectedRow(tempContacts);
    }

    const handleSaveChanges = () => {
        let tempContacts = [...formObj.contacts || []];
        if (selectedRow && (selectedIndex || selectedIndex === 0)) {
            tempContacts[selectedIndex] = selectedRow;
            handleFormObjChange('contacts', tempContacts);
            setSelectedRow(null);
            setSelectedIndex(null);

        } else {
            tempContacts.push(newContact);
            handleFormObjChange('contacts', tempContacts);
            setNewContact({});
        }
        setOpenDialog(false);
    }

    const handleDeleteContact = () => {
        let tempContacts = [...formObj.contacts || []];
        if (selectedIndex || selectedIndex === 0) {
            tempContacts.splice(selectedIndex, 1);
            handleFormObjChange('contacts', tempContacts);
            setSelectedIndex(null);
        }
        setDeleteOpen(false);
    }

    const handleSetAsDefault = () => {
        let tempContacts = [...formObj.contacts || []];
        tempContacts = tempContacts.map((contact, index) => {
            if (index === selectedIndex) {
                return { ...contact, is_default: true }
            } else {
                return { ...contact, is_default: false }
            }
        })
        handleFormObjChange('contacts', tempContacts);
        setSelectedRow(null);
        setSelectedIndex(null);
        setDefaultOpen(false);
    }

    const handleSubmit = async (proceedWithoutCheckImage = false) => {
        setIsLoading(true);
        // setShowSubmitLoadingMessage(true);
        setPhotoState(0);
        let is_image_not_masked = false;
        // Filter out any body_type ids that do not exist in the current filterBodyList
        const validIds = Array.isArray(filterBodyList) ? new Set(filterBodyList.map(b => String(b?.bike_type_id ?? b?.id))) : new Set();
        let data = Array.isArray(formObj?.body_type) ? formObj.body_type.filter(id => validIds.has(String(id))) : [];
        let payload = {
            id: advertDetails?.id,
            data: {
                action: 'edit_advert',
                bike_advert_type: formObj?.advert_type,
                bike_advert_plan_id: formObj?.bike_advert_plan_id,
                bike_make_id: formObj?.make_id,
                bike_model_id: formObj?.model_id,
                register_number: formObj?.register_number,
                license_category_id: formObj?.license_categories,
                bike_model_colour_id: formObj?.model_colour_id,
                colour_text: formObj?.colour_text,
                body_types: data,
                transmission: formObj?.transmission,
                engine_cc: formObj?.engine_cap,
                vehicle_source: formObj?.vehicle_source,
                title: `${make_name || ""} ${model_name || ""} ${formObj?.title_remark || ''}`,
                title_remark: formObj?.title_remark,
                description: formObj?.description,
                test_ride_url: formObj?.test_ride_url,
                test_ride_salesman_id: formObj?.test_ride_salesman_id,
                taggings: formObj?.taggings,
                featured_tagging_id: formObj?.featured_tagging_id || null,
                manu_year: formObj?.manu_year || null,
                registration_date: formObj?.registration_date ? moment(formObj?.registration_date).format('YYYY-MM-DD') : null,
                youtube_url: formObj?.youtube_url,
                facebook_url: formObj?.facebook_url,
                instagram_url: formObj?.instagram_url,
                tiktok_url: formObj?.tiktok_url,
                images: []
            }
        }
        if (!isDirectSeller) {
            const availablePriceTypes = formObj?.advert_type === 'used' ? [4, 2, 3] : [1, 2, 3];
            if (formObj?.advert_type !== "rental") {
                payload.data.pricing_type = formObj?.pricing_type;
                payload.data.pricings = availablePriceTypes.map(priceType => {
                    const ptData = formObj?.price_type_data?.[priceType] || {};

                    const entry = {
                        pricing_type: priceType,
                        min_downpayment: ptData.min_downpayment === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(ptData.min_downpayment) ? null : Number(ptData.min_downpayment),
                        loan_amount: ptData.loan_amount === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(ptData.loan_amount) ? null : Number(ptData.loan_amount),
                        max_loan_tenure: ptData.max_loan_tenure === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(ptData.max_loan_tenure) ? null : Number(ptData.max_loan_tenure),
                        // interest_rate_id: ptData.interest_rate_id || null,
                        interest_rate_id: ptData.interest_rate === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(ptData.interest_rate) ? null : Number(ptData.interest_rate) || null,
                        term_charge: ptData.term_charge === "NaN" ? 0 : Helpers.isNullOrEmptyAllowZero(ptData.term_charge) ? 0 : Number(ptData.term_charge),
                        monthly_instalment: ptData.monthly_instalment === "NaN" ? 0 : Helpers.isNullOrEmptyAllowZero(ptData.monthly_instalment) ? 0 : Number(ptData.monthly_instalment),
                    };
                    if (priceType === 1) {
                        entry.machine_price = ptData.machine_price === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(ptData.machine_price) ? null : Number(ptData.machine_price);
                        entry.coe = ptData.coe === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(ptData.coe) ? null : Number(ptData.coe);
                        entry.additional_cost = ptData.additional_costs === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(ptData.additional_costs) ? null : Number(ptData.additional_costs);
                    } else if (priceType === 3) {
                        entry.promotion_price = ptData.promotion_price === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(ptData.promotion_price) ? null : Number(ptData.promotion_price);
                    } else if (priceType === 4) {
                        entry.selling_price = ptData.selling_price === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(ptData.selling_price) ? null : Number(ptData.selling_price);
                    }
                    return entry;
                });
            }
            payload.data.salesmans = formObj?.salesmans;
        } else {
            payload.data.pricing_type = 4; // Direct seller only has selling price
            payload.data.salesmans = formObj?.salesmans?.map((contact) => {
                return {
                    name: contact?.salesman_name || contact?.name,
                    phone: contact?.salesman_phone || contact?.phone,
                }
            }) || [];
            payload.data.pricings = availablePriceTypes.map(priceType => {
                const ptData = formObj?.price_type_data?.[priceType] || {};
                const entry = {
                    pricing_type: priceType,
                }; if (priceType === 3) {
                    entry.promotion_price = ptData.promotion_price === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(ptData.promotion_price) ? null : Number(ptData.promotion_price);
                    entry.selling_price = ptData.selling_price === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(ptData.selling_price) ? null : Number(ptData.selling_price);
                } else if (priceType === 4) {
                    entry.selling_price = ptData.selling_price === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(ptData.selling_price) ? null : Number(ptData.selling_price);
                }
                return entry;
            });
        }

        if (formObj?.advert_type === 'used') {
            payload.data.manu_year = formObj?.manu_year || null;
            payload.data.mileage_in_km = formObj?.mileage_in_km;
            payload.data.no_of_previous_owners = formObj?.no_of_previous_owners;
            payload.data.coe_expiry = formObj?.coe_expiry;
        }
        if (formObj?.advert_type === 'rental') {
            payload.data.daily_rate = formObj?.daily_rate;
            payload.data['3_days_rate'] = formObj?.three_day_rate;
            payload.data.weekend_rate = formObj?.weekend_rate;
            payload.data.weekly_rate = formObj?.weekly_rate;
            payload.data.monthly_rate = formObj?.monthly_rate;
        }

        if (formObj?.photos && formObj?.photos.length > 0) {
            const totalPhotos = formObj.photos.length;
            let completedPhotos = 0;

            const imageResults = await Promise.all(
                formObj.photos.map(async (_, index) => {
                    const img = formObj.photos[index];
                    // Submit-time plate detection is temporarily disabled.
                    // const imageNotMasked = proceedWithoutCheckImage ? false : await PlateNoDetectionHelper(img.file_base64);
                    const imageNotMasked = false;

                    // completedPhotos += 1;
                    // setPhotoState(Math.min(99, Math.round((completedPhotos / totalPhotos) * 100)));

                    return {
                        imageNotMasked,
                        image: {
                            id: img?.edited ? null : img?.id || null,
                            is_thumbnail: img?.is_thumbnail ? 1 : 0,
                            name: img?.file_name,
                            file: img?.file_base64,
                        },
                    };
                })
            );

            is_image_not_masked = imageResults.some(result => result.imageNotMasked);
            payload.data.images.push(...imageResults.map(result => result.image));
        }

        if (!proceedWithoutCheckImage && is_image_not_masked) {
            setIsLoading(false);
            setShowSubmitLoadingMessage(false);
            setErrorModalOpen(true);
            // setNotification({ open: true, msg: 'Please ensure all images have the number plate masked before submitting.', type: 'error' });
            return;
        }
        setPhotoState(100);
        dispatch(updateAdvert(payload));
    }

    const vehicleInfoForm = () => {
        return (
            <div id="vehicle-info-section">
                {generalCommonCode?.code === "success" &&
                    <>
                        <div className="text-semibold pb-2">Advert Plan</div>
                        {advertDetails?.status !== "draft" ? <Box>
                            <Grid container spacing={1} pb={4}>
                                {isDirectSeller &&
                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <CustomTextField
                                            title={' Listing Type'}
                                            placeholder={'Listing Type'}
                                            values={isSingPass ? "MyInfo" : "Manual Entry"}
                                            disabled={true}
                                        // onChange={(e) => handleFormObjChange('engine_cap', e)}
                                        />
                                    </Grid>}
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <CustomTextField
                                        title={'Plan Name'}
                                        placeholder={'Plan Name'}
                                        values={advertDetails?.advert_plan?.title}
                                        disabled={true}
                                    // onChange={(e) => handleFormObjChange('engine_cap', e)}
                                    />
                                </Grid>

                                {!isDirectSeller && <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <CustomTextField
                                        title={'Credit Cost'}
                                        placeholder={'Credit Cost'}
                                        values={advertDetails?.advert_plan?.credit_required}
                                        disabled={true}
                                    // onChange={(e) => handleFormObjChange('engine_cap', e)}
                                    />
                                </Grid>}
                            </Grid>
                        </Box>
                            :
                            <>
                                <div className="pb-4">
                                    {isDirectSeller &&
                                        <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <CustomTextField
                                                title={' Listing Type'}
                                                placeholder={'Listing Type'}
                                                values={isSingPass ? "MyInfo" : "Manual Entry"}
                                                disabled={true}
                                            // onChange={(e) => handleFormObjChange('engine_cap', e)}
                                            />
                                        </Grid>}
                                    <PlanInfo
                                        formObj={formObj}
                                        handleFormChange={handleFormObjChange}
                                        isDirectSeller={isDirectSeller}
                                        planList={planList}
                                        userData={userData}
                                        error={error?.bike_advert_plan_id}
                                    />
                                </div>


                            </>


                        }
                    </>
                }
                <Box>
                    <div className="text-semibold">Make & Model</div>
                    <Grid container spacing={2}>
                        {isSingPass &&
                            <>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <CustomTextField
                                        title={'Make (Myinfo) '}
                                        disabled={true}
                                        values={advertDetails?.myinfo_make || ''}

                                    />
                                </Grid>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <CustomTextField
                                        title={'Model (Myinfo) '}
                                        values={advertDetails?.myinfo_model || ''}
                                        disabled={true}
                                    />
                                </Grid>
                            </>}
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomSelect
                                title={'Make'}
                                placeholder={'Make'}
                                disabled={isDirectPublished || isSingPass || isDirectSingPassPublished}
                                values={formObj?.make_id || ''}
                                onChange={(e) => { handleFormObjChange('make_id', e); setPreSelectBodyType([]); handleFormObjChange('model_id', ''); handleFormObjChange('model_colour_id', ''); handleFormObjChange('body_type', ''); }}
                                data={makeList || []}
                                labelName={'name'}
                                valueName={'id'}
                                error={error?.bike_make_id}
                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomSelect
                                title={'Model'}
                                placeholder={'Model'}
                                values={formObj?.model_id || ''}
                                onChange={(e) => { handleFormObjChange('model_id', e); }}
                                data={filterModelList || []}
                                labelName={'name'}
                                disabled={isDirectPublished || isDirectSingPassPublished}
                                valueName={'id'}
                                error={error?.bike_model_id}
                                InputProps={{
                                    //if not match with admin setup
                                    // endAdornment:
                                    //     <AppTooltip
                                    //         icon="solar:danger-triangle-linear"
                                    //         iconColor="#D13536"
                                    //         backgroundColor={'#000000'}
                                    //         textColor={'white'}
                                    //         message={'Value doesn’t match our make or model list. Please edit to select a valid option or contact admin to update the correct model.'}
                                    //     />
                                }}
                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomTextField
                                title={'Year of manufacture'}
                                placeholder={'Year of manufacture'}
                                values={formObj?.manu_year || ''}
                                isOptional={true}
                                disabled={isSingPass || isDirectSingPassPublished}
                                onChange={(e) => handleFormObjChange('manu_year', e)}
                                error={error?.manu_year}
                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomSelect
                                title={'License Category'}
                                placeholder={'License Category'}
                                values={formObj?.license_categories || ''}
                                onChange={(e) => handleFormObjChange('license_categories', e)}
                                data={license_categories || []}
                                labelName={'name'}
                                valueName={'id'}
                                error={error?.license_category_id}
                                disabled={isDirectSingPassPublished}
                            />
                        </Grid>
                    </Grid>
                </Box>
                {advertDetails?.bike_advert_type !== "used" &&
                    <Box mt={4}>
                        <div className="text-semibold">Primary Colour <span className="optional-label me-2">Optional</span></div>
                        <Stack sx={{ flexDirection: 'row', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                            {filterColorList?.length > 0 ? filterColorList?.map((color, index) => (
                                <div className={formObj?.model_colour_id === color.id ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => { handleFormObjChange('model_colour_id', formObj?.model_colour_id === color.id ? null : color.id); handleFormObjChange('colour_text', null); }}>
                                    {color.name}
                                </div>
                            )) || <div className="subheader-2">No Data Available</div> : defaultColorList?.length > 0 && (defaultColorList.map((color, index) => (
                                <div className={formObj?.colour_text && (formObj?.colour_text === color?.value) ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => { handleFormObjChange('colour_text', formObj?.colour_text === color?.value ? null : color?.value); handleFormObjChange('model_colour_id', null); }}>
                                    {color?.label}
                                </div>
                            ))) || <div className="subheader-2">No Data Available</div>
                            }
                        </Stack>

                    </Box>}
                <Box mt={4}>
                    <div className="text-semibold">Body Type</div>
                    <div className="subheader-2">Select one or more</div>
                    <Stack sx={{ flexDirection: 'row', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                        {filterBodyList?.length > 0 ? filterBodyList?.map((item, index) => (
                            <div className={preSelectBodyType?.length > 0 && preSelectBodyType?.includes(item?.id || item?.bike_type_id) ? "default-selected" : formObj?.body_type?.includes(item?.id || item?.bike_type_id) ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => handleSelectBodyType(item)}>
                                {item?.name}
                            </div>
                        )) : <div className="subheader-2">No Data Available</div>}
                    </Stack>
                    {error?.body_types && <FormHelperText error={!!error?.body_types} sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.body_types}</FormHelperText>}
                </Box>
                <Box mt={4}>
                    <div className="text-semibold">Specification</div>
                    <Grid container spacing={2}>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomSelect
                                title={'Transmission'}
                                placeholder={'Transmission'}
                                values={formObj?.transmission || ''}
                                onChange={(e) => handleFormObjChange('transmission', e)}
                                data={transmissionList}
                                labelName={'name'}
                                valueName={'id'}
                                disabled={isDirectSingPassPublished}
                                error={error?.transmission}
                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomTextField
                                title={'Engine capacity (cc)'}
                                placeholder={'Engine capacity (cc)'}
                                values={formObj?.engine_cap || ''}
                                onChange={(e) => handleFormObjChange('engine_cap', e)}
                                error={error?.engine_cc}
                                disabled={isDirectSingPassPublished}
                            />
                        </Grid>
                        {
                            advertDetails?.bike_advert_type === 'used' &&
                            <>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <CustomizedDatePicker
                                        title={"Registration date"}
                                        values={formObj?.registration_date && new Date(formObj?.registration_date)}
                                        placeholder={"dd/mm/yyyy"}
                                        disabled={isDirectSingPassPublished || isSingPass}
                                        setFormValues={(e) => handleFormObjChange('registration_date', e)}
                                        error={error?.registration_date}
                                    />
                                </Grid>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <CustomizedDatePicker
                                        title={"COE expiry date"}
                                        values={formObj?.coe_expiry && new Date(formObj?.coe_expiry)}
                                        placeholder={"dd/mm/yyyy"}
                                        disabled={isDirectSingPassPublished || isSingPass}
                                        setFormValues={(e) => handleFormObjChange('coe_expiry', e)}
                                        error={error?.coe_expiry}
                                    />
                                </Grid>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <CustomTextField
                                        title={'Mileage (KM)'}
                                        placeholder={'Mileage (KM)'}
                                        isOptional={true}
                                        type={'number'}
                                        values={formObj?.mileage_in_km ?? ""}
                                        onChange={(e) => handleFormObjChange('mileage_in_km', e)}
                                        error={error?.mileage_in_km}
                                    />
                                </Grid>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <CustomTextField
                                        title={'No. of previous owner(s)'}
                                        placeholder={'No. of previous owner(s)'}
                                        type={'number'}
                                        disabled={isDirectSingPassPublished || isSingPass}
                                        values={formObj?.no_of_previous_owners}
                                        onChange={(e) => handleFormObjChange('no_of_previous_owners', e)}
                                        error={error?.no_of_previous_owners}
                                    />
                                </Grid>
                            </>
                        }
                    </Grid>
                </Box>
                {formObj?.advert_type !== 'rental' && formObj?.advert_type !== 'used' &&
                    <Box mt={4}>
                        <div className="text-semibold">Vehicle Source <span className="optional-label me-2">Optional</span></div>
                        <Stack sx={{ flexDirection: 'row', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                            {Helpers.vehicleSourceList.map((source, index) => (
                                <div className={formObj?.vehicle_source === source.value ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => !isDirectSingPassPublished && handleFormObjChange('vehicle_source', formObj?.vehicle_source === source.value ? null : source.value)}>
                                    {source.label}
                                </div>
                            ))}
                        </Stack>
                    </Box>}
            </div>
        )
    }

    const pricingInfo = () => {
        // const isInterestRateExist = priceTypeData?.interest_rate_id && (interestRateOptions?.find((item) => item.id === priceTypeData?.interest_rate_id) || false);
        // const interestRateList = isInterestRateExist ? interestRateOptions : [{ interest_rate: priceTypeData?.interest_rate, id: 'not_exist' }, ...interestRateOptions];
        return (
            <div id="pricing-info-section">
                {
                    formObj?.advert_type === 'rental' ?
                        <Box mt={4}>
                            <div className="text-semibold mb-2">Rental Rate</div>
                            <div className="subheader-2 mb-2">Please enter at least one rental rate (daily, 3-day, weekly, or monthly) before continuing.</div>
                            <Grid container spacing={2}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <CustomTextField
                                        title={'Daily rate'}
                                        placeholder={'Daily rate'}
                                        values={formObj?.daily_rate}
                                        onChange={(e) => handleFormObjChange('daily_rate', e)}
                                        InputProps={{ startAdornment: '$' }}
                                        error={error?.daily_rate}
                                    // disabled={isDirectSingPassPublished}
                                    />
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <CustomTextField
                                        title={'Weekend rate'}
                                        placeholder={'Weekend rate'}
                                        values={formObj?.weekend_rate}
                                        onChange={(e) => handleFormObjChange('weekend_rate', e)}
                                        InputProps={{ startAdornment: '$' }}
                                        error={error?.weekend_rate}
                                    // disabled={isDirectSingPassPublished}
                                    />
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <CustomTextField
                                        title={'3-day rate'}
                                        placeholder={'3-day rate'}
                                        values={formObj?.three_day_rate}
                                        onChange={(e) => handleFormObjChange('three_day_rate', e)}
                                        InputProps={{ startAdornment: '$' }}
                                        // disabled={isDirectSingPassPublished}
                                        error={error?.['3_days_rate'] || error?.['three_day_rate']}
                                    />
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <CustomTextField
                                        title={'Weekly rate'}
                                        placeholder={'Weekly rate'}
                                        values={formObj?.weekly_rate}
                                        onChange={(e) => handleFormObjChange('weekly_rate', e)}
                                        InputProps={{ startAdornment: '$' }}
                                        error={error?.weekly_rate}
                                    // disabled={isDirectSingPassPublished}
                                    />
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <CustomTextField
                                        title={'Monthly rate'}
                                        placeholder={'Monthly rate'}
                                        values={formObj?.monthly_rate}
                                        onChange={(e) => handleFormObjChange('monthly_rate', e)}
                                        InputProps={{ startAdornment: '$' }}
                                        error={error?.monthly_rate}
                                    // disabled={isDirectSingPassPublished}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                        :
                        <>
                            {
                                !isDirectSeller &&
                                <>
                                    <Box mt={4}>
                                        <div className="text-semibold">Price to be shown on ad listing</div>
                                        <Stack sx={{ flexDirection: 'row', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                                            {priceTypeList.map((price, index) => (
                                                <div
                                                    key={price.value}
                                                    className={formObj?.pricing_type === price.value ? "vehicle-small-button-selected" : "vehicle-small-button"}
                                                    onClick={() => isDirectPublished ? null : handleFormObjChange('pricing_type', price.value)}
                                                >
                                                    {price.label}
                                                </div>
                                            ))}
                                        </Stack>
                                        {formObj?.advert_type?.toLowerCase() === 'new' && selectedPricingTypeExplanation && (
                                            <Box mt={2}>
                                                {/* <div className="text-semibold font-size-14">{selectedPricingTypeExplanation.title}</div> */}
                                                <div className="subheader-2 mt-1">{selectedPricingTypeExplanation.description}</div>
                                            </Box>
                                        )}
                                    </Box>
                                    <Box mt={4}>
                                        <div className="text-semibold">Pricing Details</div>
                                        <Grid container spacing={2}>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                                <CustomTextField
                                                    title={'Purchase cost'}
                                                    placeholder={'Purchase cost'}
                                                    values={formObj?.purchase_cost}
                                                    onChange={(e) => handleFormObjChange('purchase_cost', e)}
                                                    InputProps={{ startAdornment: '$' }}
                                                    disabled={true}
                                                    error={error?.purchase_cost}
                                                />
                                            </Grid>
                                            {advertDetails?.bike_advert_type?.toLowerCase() !== "used" &&
                                                <>   <Grid item lg={6} md={6} sm={12} xs={12}>
                                                    <CustomTextField
                                                        title={'ARF'}
                                                        placeholder={'ARF'}
                                                        values={formObj?.arf}
                                                        onChange={(e) => handleFormObjChange('arf', e)}
                                                        InputProps={{ startAdornment: '$' }}
                                                        disabled={true}
                                                        error={error?.arf}
                                                    />
                                                </Grid>


                                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                                        <CustomTextField
                                                            title={'Purchase Cost + ARF'}
                                                            placeholder={'Purchase Cost + ARF'}
                                                            type={'number'}
                                                            is2dp={true}
                                                            disabled={true}
                                                            values={Number(Number(formObj?.purchase_cost) + Number(formObj?.arf)).toFixed(2) || '0.00'}
                                                            // onChange={(e) => handleFormChange('purchase_price', e)}
                                                            InputProps={{ startAdornment: '$' }}
                                                        />
                                                    </Grid>
                                                </>}
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                                <CustomTextField
                                                    title={'Recommended selling price'}
                                                    placeholder={'Recommended selling price'}
                                                    values={formObj?.recommended_selling_price}
                                                    onChange={(e) => handleFormObjChange('recommended_selling_price', e)}
                                                    InputProps={{ startAdornment: '$' }}
                                                    disabled={true}
                                                    error={error?.recommended_selling_price}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </>
                            }

                            <Box mt={4}>
                                <div className="text-semibold">Define how much you’re selling this motorcycle for</div>
                                <Grid container spacing={2}>
                                    {
                                        isDirectSeller ?
                                            <>
                                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                                    <CustomTextField
                                                        title={'Selling Price'}
                                                        placeholder={'Selling Price'}
                                                        values={priceTypeData?.selling_price}
                                                        onChange={(e) => handlePTDChange('selling_price', e)}
                                                        type={'number'}
                                                        is2dp={true}
                                                        // disabled={isDirectSingPassPublished}
                                                        InputProps={{ startAdornment: '$' }}
                                                        error={pricingError('selling_price') || pricingError('machine_price') || ""}
                                                    />
                                                </Grid>
                                                {
                                                    formObj?.pricing_type === 3 &&
                                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                                        <CustomTextField
                                                            title={'Promotion Price'}
                                                            placeholder={'Promotion Price'}
                                                            values={priceTypeData?.promotion_price}
                                                            onChange={(e) => handlePTDChange('promotion_price', e)}
                                                            type={'number'}
                                                            is2dp={true}
                                                            // disabled={isDirectSingPassPublished}
                                                            InputProps={{ startAdornment: '$' }}
                                                            error={pricingError('promotion_price')}
                                                        />
                                                    </Grid>
                                                }
                                            </>
                                            : formObj?.pricing_type === 1 ?
                                                <>
                                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                                        <CustomTextField
                                                            title="Machine Price"
                                                            placeholder="Machine Price"
                                                            values={priceTypeData?.machine_price}
                                                            onChange={(e) => handlePTDChange('machine_price', e)}
                                                            InputProps={{ startAdornment: '$' }}
                                                            type={'number'}
                                                            is2dp={true}
                                                            // disabled={isDirectSingPassPublished}
                                                            error={pricingError('machine_price')}
                                                        />
                                                    </Grid>
                                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                                        <CustomTextField
                                                            title={'COE'}
                                                            placeholder={'COE'}
                                                            values={priceTypeData?.coe}
                                                            onChange={(e) => handlePTDChange('coe', e)}
                                                            type={'number'}
                                                            is2dp={true}
                                                            disabled={true}
                                                            // disabled={isDirectSingPassPublished}
                                                            InputProps={{
                                                                startAdornment: '$',
                                                                endAdornment:
                                                                    <ButtonBase className="mt-2" onClick={() => { setBindingResultOpen(true) }}>
                                                                        <Icon icon={'ri:question-line'} style={{ fontSize: 20, color: '#808588' }} />
                                                                    </ButtonBase>
                                                            }}
                                                            error={pricingError('coe')}
                                                        />
                                                    </Grid>


                                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                                        <CustomTextField
                                                            title={'Additional Cost ($)'}
                                                            values={priceTypeData?.additional_costs}
                                                            onChange={(e) => {
                                                                handlePTDChange('additional_costs', e)
                                                            }}
                                                            // disabled={isDirectSingPassPublished}
                                                            InputProps={{ startAdornment: '$' }}
                                                            type={'number'}
                                                            is2dp={true}
                                                            error={pricingError('additional_costs')}
                                                        />
                                                    </Grid>

                                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                                        <CustomTextField
                                                            title={'Price to be Advertised ($)'}
                                                            placeholder={'Price to be Advertised ($)'}
                                                            values={Number(Number(priceTypeData?.machine_price || 0) + Number(priceTypeData?.coe || 0) + Number(priceTypeData?.additional_costs || 0)).toFixed(2) || 0}
                                                            // onChange={(e) => {
                                                            //     handleFormChange('price_to_be_advertised', e)
                                                            // }}
                                                            disabled={true}
                                                            InputProps={{ startAdornment: '$' }}
                                                            type={'number'}
                                                            is2dp={true}
                                                            error={pricingError('price_to_be_advertised')}
                                                        />
                                                    </Grid>
                                                </> : formObj?.pricing_type === 3 ?
                                                    <>
                                                        <Grid item lg={6} md={6} sm={12} xs={12}>
                                                            <CustomTextField
                                                                title={'Promotion price'}
                                                                placeholder={'Promotion price'}
                                                                values={priceTypeData?.promotion_price}
                                                                onChange={(e) => handlePTDChange('promotion_price', e)}
                                                                InputProps={{ startAdornment: '$' }}
                                                                type={'number'}
                                                                // disabled={isDirectSingPassPublished}
                                                                error={pricingError('promotion_price')}
                                                                is2dp={true}
                                                            />
                                                        </Grid>
                                                    </> : formObj?.pricing_type === 4 ?
                                                        <>
                                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                                                <CustomTextField
                                                                    title={'Selling Price'}
                                                                    placeholder={'Selling Price'}
                                                                    values={priceTypeData?.selling_price}
                                                                    onChange={(e) => handlePTDChange('selling_price', e)}
                                                                    type={'number'}
                                                                    InputProps={{ startAdornment: '$' }}
                                                                    is2dp={true}
                                                                    // disabled={isDirectSingPassPublished}
                                                                    error={pricingError('selling_price')}
                                                                />
                                                            </Grid>
                                                        </>
                                                        : <></>
                                    }
                                    {
                                        !isDirectSeller &&
                                        <>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                                <CustomTextField
                                                    title={'Min. downpayment'}
                                                    placeholder={'Min. downpayment'}
                                                    values={priceTypeData?.min_downpayment}
                                                    onChange={(e) => handlePTDChange('min_downpayment', e)}
                                                    type={'number'}
                                                    InputProps={{ startAdornment: '$' }}
                                                    is2dp={true}
                                                    // disabled={isDirectSingPassPublished}
                                                    error={pricingError('min_downpayment')}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                                <CustomTextField
                                                    title={formObj?.pricing_type !== 2 ? 'Loan amount' : "Estimated loan amount"}
                                                    placeholder={formObj?.pricing_type !== 2 ? 'Loan amount' : "Estimated loan amount"}
                                                    values={priceTypeData?.loan_amount}
                                                    onChange={(e) => handlePTDChange('loan_amount', e)}
                                                    type={'number'}
                                                    disabled={formObj?.pricing_type !== 2 ? true : false || isDirectPublished}
                                                    InputProps={{ startAdornment: '$' }}
                                                    is2dp={true}
                                                    error={pricingError('loan_amount')}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                                <CustomTextField
                                                    title={'Max. loan tenure (months)'}
                                                    // placeholder={'Max. loan tenure (months)'}
                                                    values={priceTypeData?.max_loan_tenure ?? ""}
                                                    type={'integer'}
                                                    // disabled={isDirectSingPassPublished}
                                                    onChange={(e) => {
                                                        if (Number(e) > (formObj?.advert_type === "new" ? 120 : formObj.max_loan_tenure_calculated)) {
                                                            setNotification({ open: true, type: 'error', msg: "Max. Loan Tenure cannot exceed " + (formObj?.advert_type === "new" ? 120 : formObj.max_loan_tenure_calculated) + " months." });
                                                            // handlePTDChange('max_loan_tenure', priceTypeData.default_loan_tenure);
                                                            return;
                                                        } else {
                                                            handlePTDChange('max_loan_tenure', e)
                                                        }
                                                    }}
                                                    error={pricingError('max_loan_tenure')}
                                                    subtitle={"Max. Loan Tenure cannot exceed " + (formObj?.advert_type === "new" ? 120 : formObj?.max_loan_tenure_calculated) + "."}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                                <CustomSelect
                                                    key={currentPricingType}
                                                    title={'Interest rate (%)'}
                                                    placeholder={'Interest rate (%)'}
                                                    // freeSolo={true}
                                                    // disabled={isDirectSingPassPublished}
                                                    values={priceTypeData?.interest_rate}
                                                    data={interestRateOptions?.map((x, idx) => ({ ...x, interest_rate: Number(x?.interest_rate)?.toFixed(2) }))}
                                                    labelName={'interest_rate'}
                                                    valueName={'interest_rate'}
                                                    onChange={(e, value) => {
                                                        // if (value === null || value === undefined || value === '') return;
                                                        // // When selecting an existing option, value is the full option object.
                                                        // // When typing a new freeSolo value, value is a string or { inputValue }.
                                                        // const rawVal = value && typeof value === 'object'
                                                        //     ? (value?.inputValue ?? value?.interest_rate)
                                                        //     : value;
                                                        // if (rawVal === null || rawVal === undefined || rawVal === '' || rawVal === 'NaN') return;
                                                        // const numVal = Number(rawVal);
                                                        // const formatted = Number.isNaN(numVal) ? String(rawVal) : numVal.toFixed(2);
                                                        // const exists = interestRateOptions?.some(
                                                        //     (item) => Number(item?.interest_rate).toFixed(2) === formatted
                                                        // );
                                                        // if (!exists) {
                                                        //     const newOption = { interest_rate: Number.isNaN(numVal) ? rawVal : numVal, license_category_id: null };
                                                        //     setInterestRateOptions(prev => [newOption, ...(prev || [])]);
                                                        // }
                                                        handlePTDChange('interest_rate', e);
                                                    }}
                                                    error={pricingError('interest_rate') || pricingError('interest_rate') || ""}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                                <CustomTextField
                                                    title={'Term charge'}
                                                    placeholder={'Term charge'}
                                                    values={priceTypeData?.term_charge}
                                                    type={'number'}
                                                    disabled={true}
                                                    is2dp={true}
                                                    onChange={(e) => ""}
                                                    InputProps={{ startAdornment: '$' }}
                                                    error={pricingError('term_charge')}
                                                />
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                                <CustomTextField
                                                    title={'Monthly instalment'}
                                                    placeholder={'Monthly instalment'}
                                                    values={priceTypeData?.monthly_instalment || 0.00}
                                                    type={'number'}
                                                    is2dp={true}
                                                    disabled={true}
                                                    onChange={(e) => handlePTDChange('monthly_instalment', e)}
                                                    InputProps={{ startAdornment: '$' }}
                                                    error={pricingError('monthly_instalment')}
                                                />
                                            </Grid>
                                        </>
                                    }
                                </Grid>
                            </Box>
                        </>
                }
            </div>
        )
    }

    const advertDetailsForm = () => {
        return (
            <div id="ad-details-section">
                <Box mt={4}>
                    <div className="text-semibold">Advert Title</div>
                    <Grid container spacing={1}>
                        <Grid item sm={12} xs={12}>
                            <CustomTextField
                                title={'Listing Title'}
                                placeholder={'Listing Title'}
                                values={`${make_name || ""} ${model_name || ""} ${formObj?.title_remark || ''}`}
                                onChange={(e) => handleFormObjChange('title', e)}
                                disabled={true}
                                error={error?.title}
                            />
                        </Grid>
                        <Grid item sm={12} xs={12}>
                            <CustomTextField
                                title={'Listing Title Remark'}
                                placeholder={'Listing Title Remark'}
                                values={formObj?.title_remark || ''}
                                error={error?.title_remark}
                                // disabled={isDirectSingPassPublished}
                                subtitle={`${formObj?.title_remark ? formObj.title_remark.length : 0}/255 characters`}
                                onChange={(e) => {
                                    if (e?.length <= 255) {
                                        handleFormObjChange('title_remark', e)
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Box mt={4}>
                    <div className="text-semibold mb-2">Listing Description</div>
                    <Grid container spacing={2}>
                        <Grid item sm={12} xs={12}>
                            <FormEditors
                                value={formObj?.description || ''}
                                setValue={(e) => handleFormObjChange('description', e)}
                                error={error?.description}
                            // disabled={isDirectSingPassPublished}
                            />
                        </Grid>
                    </Grid>
                </Box>
                {
                    !isDirectSeller &&
                    <>
                        <Box mt={4}>
                            <div className="text-semibold">Test Ride URL <span className="optional-label me-2">Optional</span></div>
                            <Grid container spacing={1}>
                                <Grid item sm={12} xs={12}>
                                    <CustomTextField
                                        title={'Test Ride URL'}
                                        placeholder={'Test Ride URL'}
                                        values={formObj?.test_ride_url || ''}
                                        // disabled={isDirectSingPassPublished}
                                        onChange={(e) => handleFormObjChange('test_ride_url', e)}
                                        error={error?.test_ride_url}
                                    />
                                </Grid>
                                <Grid item sm={12} xs={12}>
                                    <CustomSelect
                                        title={'Person In Charge'}
                                        placeholder={'Person In Charge'}
                                        values={formObj?.test_ride_salesman_id || ''}
                                        data={salesmanList}
                                        labelName={'name'}
                                        valueName={'id'}
                                        // disabled={isDirectSingPassPublished}
                                        onChange={(e) => handleFormObjChange('test_ride_salesman_id', e)}
                                        error={error?.test_ride_salesman_id}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </>
                }
                <Box mt={4}>
                    <div className="text-semibold">Tagging <span className="optional-label me-2">Optional</span></div>
                    <div className="subheader-2">
                        Select up to 3 tags. Mark one tag with a star to feature it on the mobile listing view.
                    </div>
                    <Stack sx={{ flexDirection: 'row', gap: 1, mt: 2, flexWrap: 'wrap' }}>
                        {taggings.map((tag) => (
                            <div key={tag.id} className={formObj?.taggings?.includes(tag.id) ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => handleTagChange(tag.id)}>
                                {tag?.name || ''}
                                {formObj?.taggings?.includes(tag.id) && (
                                    <Icon
                                        icon={formObj?.featured_tagging_id === tag.id ? "ri-star-fill" : "ri-star-line"}
                                        onClick={(event) => handleFeaturedTagChange(event, tag.id)}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter" || event.key === " ") handleFeaturedTagChange(event, tag.id);
                                        }}
                                        aria-label={formObj?.featured_tagging_id === tag.id ? `Remove ${tag.name} as featured` : `Set ${tag.name} as featured`}
                                        role="button"
                                        tabIndex={0}
                                        style={{ marginLeft: 8, color: formObj?.featured_tagging_id === tag.id ? "#D99600" : "inherit" }}
                                    />
                                )}
                            </div>
                        ))}
                    </Stack>
                    {error?.taggings && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.taggings || ""}</FormHelperText>}
                </Box>
            </div>
        )
    }

    const salesmanForm = () => {
        return (
            <div id="salesman-section">
                <Box mt={4} >
                    <Grid container spacing={1}>
                        {!isDirectPublished && <Grid item container sm={12} className="d-flex align-items-center mb-2">
                            <Grid>
                                {error?.salesmans && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.salesmans || ""}</FormHelperText>}
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <div className="text-semibold">Salesman</div>
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                                <CustomButton
                                    title={'Add Salesman'}
                                    press={() => window.innerWidth <= 768 ? setOpenAddSalesManModal(true) : setNewSalesman([...newSalesman || [], { salesman_id: '', location_id: '', contact: '' }])}
                                />
                            </Grid>
                        </Grid>}
                        <Grid item sm={12} xs={12}>
                            <TableStyle2
                                header={header}
                                tableData={formObj?.salesmans || []}
                                inputListing={inputListing}
                                setInput={setNewSalesman}
                                inputArr={newSalesman}
                                inputActionButton={(e) => (
                                    <div className="clickable text-underline" onClick={() => { handleSaveNewSalesman(e) }}>Save</div>
                                )}
                                width={window.innerWidth}
                                customResponsiveTable={
                                    <Grid>
                                        {formObj?.salesmans?.length > 0 ?
                                            formObj?.salesmans?.map((x, idx) => (
                                                <Box
                                                    key={idx}
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        p: 2,
                                                        border: "1px solid #E0E0E0",
                                                        borderRadius: 2,
                                                        mb: 1,
                                                    }}
                                                >
                                                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                        <span>
                                                            <b>{salesmanList?.find((salesman) => salesman.id === x?.salesman_id)?.name || "-"}</b>
                                                        </span>
                                                        <span className="text-muted">
                                                            {locationList?.find((loc) => loc.id === x?.location_id)?.branch_name || "-"}, {x?.salesman_phone || x?.contact || '-'}
                                                        </span>
                                                    </Box>
                                                    <div style={{ display: "flex", gap: 10 }}>
                                                        <Icon
                                                            icon="ri:pencil-line"
                                                            onClick={() => { setOpenAddSalesManModal(true); setSelectedRow({ ...x, temp_id: idx }); setEditIdx(idx); }}
                                                            style={{ cursor: "pointer", fontSize: 20 }}
                                                        />
                                                        <Icon
                                                            icon="ri-close-line"
                                                            onClick={() => handleRemoveSalesman(idx)}
                                                            style={{ cursor: "pointer", fontSize: 20 }}
                                                        />
                                                    </div>

                                                </Box>
                                            ))
                                            : "No salesmen assigned yet."
                                        }
                                    </Grid>
                                }
                            />
                        </Grid>
                    </Grid>
                </Box>
            </div>
        )
    }

    const contactForm = () => {
        return (
            <div id="salesman-section">
                <Box mt={4}>
                    <Grid container spacing={1}>
                        <Grid item container sm={12} className="d-flex align-items-center mb-2">
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <div className="text-semibold">Contact</div>
                            </Grid>
                            {/* <Grid item lg={6} md={6} sm={12} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                                <CustomButton
                                    title={'Add Contact'}
                                    press={() => setOpenDialog(true)}
                                />
                            </Grid> */}
                        </Grid>

                        <Grid item container sm={12} xs={12} spacing={2}>

                            <Grid item xs={12} key={""}>
                                <div className="d-flex align-items-center subheader-2">
                                    <CustomTextField
                                        title={'Contact Name'}
                                        placeholder={'Name'}
                                        values={formObj?.contacts?.[0]?.name || ''}
                                        disabled={true}
                                    />
                                </div>
                                <div className="d-flex align-items-center subheader-2 mt-2">
                                    <CustomTextField
                                        title={'Contact Phone Number'}
                                        placeholder={'Contact Phone Number'}
                                        type={'phone'}
                                        values={formObj?.contacts?.[0]?.phone || ''}
                                        disabled={true}
                                    />
                                </div>


                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </div>
        )
    }

    const mediaForm = () => {
        return (
            <div id="media-section">
                <Box mt={2}>
                    <div className="text-semibold">Upload Photos</div>
                    <div className="subheader-2">Up to 10 images of your motorcycle’s photos</div>
                    <UploadProductImagesNew
                        showLimit={false}
                        displayFiles={false}
                        values={formObj?.photos}
                        setFormValues={(e) => handleFormObjChange('photos', e)}
                        maxFile={10}
                        maxFileSize={10}
                        // disabled={isDirectSingPassPublished}
                        md={3}
                        sm={6}
                        xs={12}
                        multiple={true}
                        setNotification={setNotification}
                        images={true}
                        windowWidth={layoutWidth}
                        handleThumbnail={handleSetThumbnail}
                    />
                    {error?.images && error?.images && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.images?.length > 0 ? error?.images?.map((item, index) => <div key={index}> {item} &nbsp;</div>) : null}</FormHelperText>}
                </Box>
                <Box mt={2}>
                    <div className="text-semibold">Video URLs <span className="optional-label me-2">Optional</span></div>
                    <CustomTextField
                        title={'Youtube'}
                        placeholder={'Youtube Url'}
                        values={formObj?.youtube_url}
                        onChange={(e) => handleFormObjChange('youtube_url', e)}
                        error={error?.youtube_url}
                    // disabled={isDirectSingPassPublished}
                    />
                    <div className="mt-2">
                        <CustomTextField
                            title={'Facebook'}
                            placeholder={'Facebook Url'}
                            values={formObj?.facebook_url}
                            onChange={(e) => handleFormObjChange('facebook_url', e)}
                            error={error?.facebook_url}
                        // disabled={isDirectSingPassPublished}
                        />
                    </div>
                    <div className="mt-2">
                        <CustomTextField
                            title={'Instagram'}
                            placeholder={'Instagram Url'}
                            values={formObj?.instagram_url}
                            onChange={(e) => handleFormObjChange('instagram_url', e)}
                            error={error?.instagram_url}
                        // disabled={isDirectSingPassPublished}
                        />
                    </div>
                    <div className="mt-2">
                        <CustomTextField
                            title={'TikTok'}
                            placeholder={'TikTok Url'}
                            values={formObj?.tiktok_url}
                            onChange={(e) => handleFormObjChange('tiktok_url', e)}
                            error={error?.tiktok_url}
                        // disabled={isDirectSingPassPublished}
                        />
                    </div>
                </Box>
            </div>
        )
    }
    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: layoutWidth <= 768 && leftSideBarType === 'condensed' ? 72 : 0 }}>
                <LoadingDialog open={loading || generalCommonCode?.code !== "success"}
                // message={showSubmitLoadingMessage ? (photoState >= 100 ? "Processing completed, submitting data...please wait" : <div style={{ textAlign: "center" }}>{photoState}% <br />Processing photo please wait...</div>) : undefined}
                />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} errors={error} />
                    {advertDetailsInd?.code && advertDetailsInd?.code !== "success" ?
                        <div className="d-flex align-items-center justify-content-center" style={{ height: '70vh' }}>
                            <div className="text-center">
                                <div className="header-2 pb-3">{advertDetailsInd?.message || "Something went wrong."}</div>
                                <CustomButton
                                    title={'Go to Listing'}
                                    press={() => navigate('/advert')}
                                    padding={20}
                                />
                            </div>
                        </div> :
                        <>
                            <Grid container spacing={{ xs: 0.5, sm: 2 }} px={1} pt={{ xs: 0.5, sm: 2 }} style={{ position: 'fixed', backgroundColor: 'white', zIndex: 9, marginTop: -25, width: '100%' }}>
                                <Grid item sm={12}>
                                    <CustomButton
                                        title={
                                            <div className="d-flex align-items-center" style={{ fontWeight: 400 }}>
                                                <Icon icon={'fluent:chevron-left-20-regular'} style={{ marginRight: 10 }} />Back to details
                                            </div>
                                        }
                                        borderRadius={"5px"}
                                        borderStyle={"0px"}
                                        backgroundColor={"transparent"}
                                        textColor={"#000000"}
                                        paddingInline={7}
                                        press={() => navigate(`/advert/${advertDetails?.id}`)}
                                    />
                                </Grid>
                                <Grid item xs={12} pr={0} mr={0}>
                                    <div className="px-2">
                                        <div className="header d-flex" style={{ flexWrap: 'wrap', wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                                            {advertDetails?.info?.title || '-'}
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} style={{ flexWrap: 'wrap' }}>
                                    <AppTab tabValue={tabValue} setTabValue={(e) => { handleTabValue(e) }} tabList={tabList} indicatorColor={'#1D1B1B'} />
                                </Grid>
                            </Grid>
                            <div id="content-container" style={{ paddingTop: layoutWidth <= 768 ? 130 : 200 }}>
                                <Grid container spacing={2} px={3} pb={5}>
                                    <Grid item xs={12}>
                                        {vehicleInfoForm()}
                                    </Grid>
                                    <Grid item xs={12}>
                                        {pricingInfo()}
                                    </Grid>
                                    <Grid item xs={12}>
                                        {advertDetailsForm()}
                                    </Grid>
                                    <Grid item xs={12}>
                                        {isDirectSeller ? contactForm() : salesmanForm()}
                                    </Grid>
                                    <Grid item xs={12}>
                                        {mediaForm()}
                                    </Grid>
                                </Grid>
                            </div>
                        </>}

                </Container>
            </div>
            {advertDetailsInd?.code && advertDetailsInd?.code !== "success" ? <></> :
                <div className="mobile-button-container d-flex justify-content-between">
                    <CustomButton
                        title={'Cancel'}
                        press={() => navigate(-1)}
                        padding={20}
                        backgroundColor={'#FFFFFF'}
                        textColor={'#1D1B1B'}
                        borderStyle={'1px solid #1D1B1B'}
                    />
                    <CustomButton
                        title={'Save Changes'}
                        press={() => handleSubmit()}
                        padding={20}
                    />
                </div>
            }

            <BindingResult
                open={bindingResultOpen}
                close={() => setBindingResultOpen(false)}
                windowWidth={layoutWidth}
                resultData={coeList?.data || []}
            />
            <AppDialog
                title={selectedRow ? 'Edit Contact' : 'Add Contact'}
                open={openDialog}
                close={() => { setOpenDialog(false); setSelectedRow(null); setNewContact({}) }}
                positiveTitle={selectedRow ? 'Save Changes' : 'Save'}
                positivePress={() => { handleSaveChanges() }}
                cancelButton={true}
                width={'40%'}
            >
                <Grid container spacing={1}>
                    <Grid item sm={12} className="subheader-2">
                        Provide contact details of the person you would like to add.
                    </Grid>
                    <Grid item sm={12}>
                        <CustomTextField
                            title={'Name'}
                            placeholder={'Name'}
                            values={selectedRow ? selectedRow?.name : newContact?.name}
                            onChange={(e) => { selectedRow ? handleEditContactChange('name', e) : handleNewContactChange('name', e) }}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        <CustomTextField
                            title={'Phone Number'}
                            placeholder={'Phone Number'}
                            type={'phone'}
                            InputProps={{
                                startAdornment: <div style={{ paddingLeft: 6, paddingRight: 10 }}>+65</div>,
                            }}
                            values={selectedRow ? selectedRow?.phone : newContact?.phone}
                            onChange={(e) => { selectedRow ? handleEditContactChange('phone', e) : handleNewContactChange('phone', e) }}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        <CustomTextField
                            title={'Email address'}
                            placeholder={'Email address'}
                            type={'email'}
                            values={selectedRow ? selectedRow?.email : newContact?.email}
                            onChange={(e) => { selectedRow ? handleEditContactChange('email', e) : handleNewContactChange('email', e) }}
                        />
                    </Grid>
                </Grid>
            </AppDialog>
            <AppDialog
                title={'Remove Contact'}
                open={deleteOpen}
                close={() => setDeleteOpen(false)}
                positiveTitle={'Remove'}
                positiveButtonStyle={{ backgroundColor: '#D13536', color: 'white', borderRadius: 20, width: 'auto', border: '1px solid #D13536' }}
                positivePress={() => handleDeleteContact()}
                cancelButton={true}
                width={'30%'}
            >
                <div className="subheader-2">Are you sure to want to remove this contact?</div>
            </AppDialog>
            <AppDialog
                title={'Set as default'}
                open={defaultOpen}
                close={() => setDefaultOpen(false)}
                positiveTitle={'Set as Default'}
                positivePress={() => handleSetAsDefault()}
                cancelButton={true}
                width={'40%'}
            >
                Are you sure you want to set <span className="text-bold">{selectedRow?.name || '-'}</span> as the <span className="text-bold">default contact</span> for this advert?
            </AppDialog>
            <AppDialog
                open={errorModalOpen}
                close={() => setErrorModalOpen(false)}
                positiveTitle={'Proceed to Submit'}
                positiveButtonStyle={{ backgroundColor: "#d32f2f", color: "white", borderRadius: 20, width: 'auto', border: '1px solid #d32f2f' }}
                negativeTitle={'Go back & Edit'}
                negativePress={() => setErrorModalOpen(false)}
                positivePress={() => { setErrorModalOpen(false); handleSubmit(true) }}
                width={'40%'}
            >
                <Grid container spacing={2}>
                    <Grid item xs={1}>
                        <ReportGmailerrorredIcon style={{ color: "#d32f2f" }} />
                    </Grid>
                    <Grid item xs={11}>
                        One or more of the uploaded images may contain visible plates number. Please ensure all images are properly masked before submitting.
                    </Grid>
                </Grid>
            </AppDialog>
            <AddSalesman
                open={openAddSalesManModal}
                salesmanList={
                    editIdx === null
                        ? (salesmanList || []).filter(
                            salesman =>
                                !formObj?.salesmans?.some(
                                    existingSm => existingSm.salesman_id === salesman.id
                                )
                        )
                        : (salesmanList || []).filter(
                            salesman =>
                                selectedRow?.salesman_id === salesman.id ||
                                (
                                    !newSalesman.some(
                                        newSm => newSm.salesman_id === salesman.id
                                    ) &&
                                    !formObj?.salesmans?.some(
                                        existingSm => existingSm.salesman_id === salesman.id
                                    )
                                )
                        )
                }
                editIdx={editIdx}
                branchList={locationList}
                values={selectedRow}
                setFormValues={setSelectedRow}
                close={() => { setOpenAddSalesManModal(false); setSelectedRow(null); setEditIdx(null); }}
                handleAdd={(data) => { handleSaveNewSalesman(data); setOpenAddSalesManModal(false); setSelectedRow(null); setEditIdx(null); }}
                handleEdit={(data) => { handleEditSalesman(data, editIdx); setOpenAddSalesManModal(false); setSelectedRow(null); setEditIdx(null); }}
            />
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Layout, Advert, General }) {
    const currentStateId = Login?.verifyAdmin?.user?.data?.profile?.state_id;
    const filteredBranchList = General?.states?.find((state) => state.id === currentStateId)?.cities || [];
    return {
        isDirectSeller: Login?.verifyAdmin?.user?.data?.profile?.selected_dealer_id ? false : true,
        username: Login.verifyAdmin?.user?.data?.profile?.name,
        userEmail: Login.verifyAdmin?.user?.data?.profile?.email,
        userPhone: Login.verifyAdmin?.user?.data?.profile?.phone,
        userData: Login?.verifyAdmin?.user?.data,
        userPermission: Login?.permissionArry,
        leftSideBarType: Layout.leftSideBarType,
        layoutWidth: Layout.currentWidth,
        advertDetails: Advert.advertDetails?.data,
        advertDetailsInd: Advert.advertDetails,
        planList: General.bike_advert_plans,
        makeList: General.bike_makes,
        modelList: General.bike_models,
        bodyList: General.bike_types,
        transmissionList: General.transmissions,
        license_categories: General.license_categories,
        salesmanList: General.dealer_salesmans,
        locationList: General?.dealer_branches || [],
        advertInterestRate: General.advertInterestRate,
        advertEdit: Advert.advertEdit,
        taggings: General.taggings,
        coeList: Advert.coeBiddingList,
        generalCommonCode: General?.generalCommonCode,
        defaultColorList: General?.default_colours,

    };
}


export default connect(mapStateToProps)(EditAdvert);
